import styled from 'styled-components'
import AllCollectionCard from '../../../CollectionsList/UI/components/CollectionItem'
import { useNavigate } from 'react-router-dom'
import { setPickedCollection } from '../../../../components/store/pickedCollection'
import { useEffect, useState } from 'react'
import { $collections, getCollections } from '../../../../components/store/collections'
import { useUnit } from 'effector-react'
import Skeleton from '../../../../UI/components/UIKit/Skeleton'
import Button from '../../../../UI/components/UIKit/Button'

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`
export const Title = styled.div`
    justify-content: space-between;
    align-items: center;
    display: flex;
`
export const Flex = styled.div`
    display: flex;
    overflow: auto;
    gap: 8px;
`

const AllCollection = () => {
    const [ isLoading, setIsLoading ] = useState(false);
    const data = useUnit($collections);
    const navigate = useNavigate();

    const relocate = () => {
        setPickedCollection(null);
        navigate('/CollectionsPage');
    }

    useEffect(()=>{
        if(!data.length){
            setIsLoading(true);
            getCollections().then(()=>setIsLoading(false));
        }
    },[])

  return (
    <Wrapper>
        <Title>
            <h2>Коллекции</h2>
            <Button mini={true} onClick={relocate}><h3>Все</h3></Button>
        </Title>
        <Flex>
            {isLoading ? 
                Array.from({ length: 3 }, (_, index) => (
                    <Skeleton key={index} width={'45vw'} height={'45vw'} radius={"12px"}/>
                ))
                :  
                data.map((item,index) => <AllCollectionCard key={index} data={item}/>)
            }
        </Flex>
    </Wrapper>
  )
}

export default AllCollection